import { lazy } from 'react';

const AnalizerTicketsViewConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/analyzer-tickets',
      component: lazy(() => import('./AnalizerTicketsViewApp')),
    },
  ],
};

export default AnalizerTicketsViewConfig;
